import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import CameraList from './pages/CameraList';
import CameraView from './pages/CameraView';
import TimelapseOverview from './pages/TimelapseOverview';
import CookieConsent from './components/CookieConsent';
import './App.css';

function App() {
  return (
    <BrowserRouter>
      <CookieConsent />
      <Routes>
        <Route path="/" element={<CameraList />} />
        <Route path="/camera/:cameraSlug" element={<CameraView />} />
        <Route path="/timelapses" element={<TimelapseOverview />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;

